import { Box, CircularProgress, Typography } from '@mui/material'
import { Logo } from './Logo'

export default function SplashScreen() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
      }}
    >
      <Logo size={80} />
      <Typography variant="h5" component="h1" color="text.secondary">
        ConnectLoop
      </Typography>
      <CircularProgress aria-label="Loading" />
    </Box>
  )
}
